import { unref } from 'vue'
import translateHelper from '@/helpers/translate'
import useTranslationStatus from '@/composables/useTranslationStatus'

function useTranslate() {
  const { translationsLoaded, translationsSettled } = useTranslationStatus()

  function translate(keyword, options) {
    return translateHelper(unref(keyword), unref(options))
  }

  return { translate, translationsLoaded, translationsSettled }
}

export default useTranslate
